import React from 'react';
import { Clock, Wrench, Package, CheckCircle, Truck, XCircle } from 'lucide-react';

interface RepairStatusBadgeProps {
  status: 'SUBMITTED' | 'IN_PROGRESS' | 'WAITING_PARTS' | 'COMPLETED' | 'DELIVERED' | 'CLOSED';
  size?: 'sm' | 'md' | 'lg';
}

const statusConfig = {
  SUBMITTED: {
    label: 'Submitted',
    icon: Clock,
    color: 'bg-blue-500/10 text-blue-500',
    borderColor: 'border-blue-500/20',
  },
  IN_PROGRESS: {
    label: 'In Progress',
    icon: Wrench,
    color: 'bg-orange-500/10 text-orange-500',
    borderColor: 'border-orange-500/20',
  },
  WAITING_PARTS: {
    label: 'Waiting for Parts',
    icon: Package,
    color: 'bg-yellow-500/10 text-yellow-500',
    borderColor: 'border-yellow-500/20',
  },
  COMPLETED: {
    label: 'Completed',
    icon: CheckCircle,
    color: 'bg-green-500/10 text-green-500',
    borderColor: 'border-green-500/20',
  },
  DELIVERED: {
    label: 'Delivered',
    icon: Truck,
    color: 'bg-purple-500/10 text-purple-500',
    borderColor: 'border-purple-500/20',
  },
  CLOSED: {
    label: 'Closed',
    icon: XCircle,
    color: 'bg-gray-500/10 text-gray-500',
    borderColor: 'border-gray-500/20',
  },
};

export const RepairStatusBadge: React.FC<RepairStatusBadgeProps> = ({ status, size = 'md' }) => {
  const config = statusConfig[status] || statusConfig.SUBMITTED;
  const Icon = config.icon;

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-3 py-1 text-sm',
    lg: 'px-4 py-1.5 text-base',
  };

  return (
    <span
      className={`inline-flex items-center rounded-full border ${config.borderColor} ${config.color} ${sizeClasses[size]}`}
    >
      <Icon className={`${size === 'sm' ? 'h-3 w-3' : size === 'md' ? 'h-4 w-4' : 'h-5 w-5'} mr-1.5`} />
      {config.label}
    </span>
  );
};